<template>
  <div id="app" > 
    <router-view name="header"></router-view>
    <router-view></router-view> 
    <router-view name="footer"></router-view>
    
  </div>
</template>

<script>
import App from './App' 
export default {
    name: 'App',
    mounted:function () {
        this.$zh_tran()    
    },
    watch:{
      $route(to){
        this.$nextTick(()=>{
          this.$zh_tran(localStorage.getItem('lang'))
        })
      }
    }
}
</script>
 
<style>
@import url('http://at.alicdn.com/t/font_2425931_qhc7n64o6c8.css');
</style>



// WEBPACK FOOTER //
// src/App.vue